import api, { ApiResponse, PageResponse } from './api'
import type { Balance, BalanceTransaction } from '../types'

interface TransactionListParams {
  page?: number
  size?: number
  type?: string
}

export function getBalance(): Promise<ApiResponse<Balance>> {
  return api.get('/v1/merchant/balance')
}

export function getTransactions(params: TransactionListParams): Promise<ApiResponse<PageResponse<BalanceTransaction>>> {
  return api.get('/v1/merchant/balance/transactions', { params })
}
